import { Component, OnInit, HostListener, Renderer } from '@angular/core';
import { HeaderService } from '../header/header.service';
import { Router } from '@angular/router';
import { AuthService } from '../../api/services/auth.service';
import { ClientLogoService } from '../services/client-logo.service';
import { AdminGuardService } from '../services/admin-guard.service';
import { SearchService } from '../../api/services/search.service';
import { UserService } from '../../api/services/user.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { SearchInput } from '../../api/models/search-result';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import { TasksService } from '../../api/services/tasks.service';
import { NotificationsPreferencesComponent } from '../notifications-preferences/notifications-preferences.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private authService: AuthService,
              private headerService: HeaderService,
              private router: Router,
              private clientLogoService: ClientLogoService,
              private adminGuardService: AdminGuardService,
              private searchService: SearchService,
              private userService: UserService,
              private preferencesService: PreferencesService,
              private renderer: Renderer,
              private modalService: NgbModal,
              private taskService: TasksService
            ) {
              this.headerService.tasksCount.subscribe(value => {
                if(value && this.currentMarketId){ this.getMyTasksCount(); }
              });
              this.headerService.marketSelectedBool.subscribe(marketSelected => {
                if(marketSelected){ this.getCurrentMarketId(); }
              });
             }

  profileImage: any;
  showMenu: false;
  clientLogo: any;
  notificationsAcknowledged: string;
  searchText = '';
  username: string;
  visibleContext: boolean = false;
  specialSelected: string;
  isVerizonUser: boolean = false;

  orgId: string;
  isTesscoAdmin: boolean = false;
  hideSelected = false;
  setFocusOnAdd = false;
  currentMarketId: string;
  tasksCount;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (event.target.id !== 'menu_profile_img') {
      this.showMenu = false;
    }
  }

  checkIfTesscoAdmin() {
    this.authService.getUserRoles(new RoleRequest('ADMIN_TESSCO', null)).subscribe(roles => {
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
    });
  }

  isAdmin() {
    return this.adminGuardService.hasAccess();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['login']);
  }

  openPreferences() {
    this.modalService.open(NotificationsPreferencesComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  search() {
    if (this.searchText.length >= 2) {
      this.searchService.resetSearchDetails(this.searchText);
      this.router.navigateByUrl('/search', { skipLocationChange: true }).then(() => {
        this.router.navigate(['search'], { queryParams: { searchText: this.searchText, orgId: this.orgId, isTesscoAdmin: this.isTesscoAdmin } });
      });      
    }
  }

  ngOnInit() {
    this.checkIfTesscoAdmin();
    this.calculatePermissions(['ORGANIZATION_UPDATE']);
    this.getCurrentMarketId();
    
    this.headerService.getProfileImage()
    .subscribe(image => {
      this.profileImage = image;
    });
    this.clientLogoService.getClientLogo()
    .subscribe(image => {
      this.clientLogo = image;
    });
   this.authService.getUserName()
   .subscribe(uName => this.username = uName);
    
    this.searchService.$searchSubject.subscribe((text) => {
      this.searchText = text;
    });
    this.searchService.$searchCleanSubject.subscribe(() => {
      this.searchText = '';
    });
  }

  getMyTasksCount() {
    if (this.currentMarketId) {
      this.taskService.getMyTasksBoolValue(this.currentMarketId).subscribe(pendingTasks => {
        this.tasksCount = (pendingTasks > 0) ? pendingTasks : 0 ;
      });
    }
  }

  calculatePermissions(requiredRoles: string[], context?: string) {
    this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
      if (user) {
        this.orgId = user['Organization ID'];
        const orgContext = `ORGANIZATION~${this.orgId}`;
        this.authService.getUserRolesInContext(orgContext).subscribe(roles => {
          this.visibleContext = requiredRoles.every(r => roles.includes(r));
        });
        this.preferencesService.getPreferences('CUSTOMER', this.orgId).subscribe(prefs => {
          this.specialSelected = prefs['special-fields'].Value;
          if (this.specialSelected === 'Verizon eQuote'){
            this.isVerizonUser = true;
          }else{
            this.headerService.getNotificationNumber().subscribe(notificationNumber => {
              this.notificationsAcknowledged = notificationNumber;
            });
          }
        });
      }
    });
  }

  onNavigate(){
    this.userService.getOasisUsersGuide().subscribe(report => {
      if(report){
        window.open(report['link'], "_blank");
      }
    });
  }

  globalAutoSuggestion = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term =>
        !term ? of([]) : this.searchService.queryGlobalAutoSuggestion(new SearchInput(term,
                          this.isTesscoAdmin === false ? localStorage.getItem('marketAccountNo') : null,
                          0, 0, this.isTesscoAdmin === false ? this.orgId : null))
        .map(results => results)
        .catch(err => {
          return of([]);
        })
      );

  suggestionFormatter = (result: string) => {
    return result;
  }
  
  getCurrentMarketId(){
    this.preferencesService.getPreferences('USER', this.authService.getUserId())
    .subscribe(prefs => {
      this.currentMarketId = prefs['current-market'].Value;
      this.getMyTasksCount();
    });
  }

  showSelectMarketPopUp() {
    const modalRef = this.modalService.open(InfoModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.name = 'Please select Market';
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/header/header.component.ts